export const getAddressLine = ({
    address,
    additionalAddress,
    city,
    state,
    zip,
    country,
}: {
    address: string | null;
    additionalAddress?: string | null;
    city: string;
    state: string;
    zip: string;
    country: string | null;
}) => {
    return `${address}, ${additionalAddress ? `${additionalAddress},` : ''} ${city}, ${state} ${zip}, ${country}`;
};
